<template>
  <div>
    <!-- 新增按钮 -->

    <DatePicker
      v-model="searchDate"
      type="daterange"
      placement="bottom-end"
      placeholder="选择时间"
      style="width: 200px"
      :options="options3"
    ></DatePicker>
    <Button type="primary" @click="resetFormData">清除</Button>

    <Button type="primary" @click="queryGoods">查询</Button>

    <Table :columns="columns10" :data="data9"> </Table>
    <div style="margin: 10px; overflow: hidden">
      <div style="float: right">
        <Page
          :total="total"
          :current="current"
          :page-size="50"
          @on-change="changePage"
        ></Page>
      </div>
    </div>

    <Modal
      v-model="rankModal"
      title="发货成本排行"
      width="800"
      :footer-hide="true"
    >
      <Table :columns="rankColumns" :data="rankData"> </Table>
    </Modal>

    <Modal
      v-model="userIdsModal"
      title="用户id"
      width="500"
      :footer-hide="true"
    >
      <Table :columns="userIdsColumns" :data="userIdsData"> </Table>
    </Modal>
  </div>
</template>

<script>
import { cmsShopStatistics, cmsShopStatisticsDetail } from "../../api/user";

export default {
  components: {},
  data() {
    return {
      selUser: {},
      reasontxt: "",
      amount: 0, // 输入的金额或者能量
      isfengjin: false,

      searchDate: [],
      loading: false,
      beizhu: "",
      clickuserid: "",
      lianxu: "",
      rankModal: false,
      rankData: [],
      rankColumns: [
        {
          title: "排名",
          key: "rank",
          render: (h, params) => {
            return h("span", String(params.index + 1));
          },
        },
        {
          title: "用户id",
          key: "user_id",
        },
        {
          title: "发货总额",
          key: "costSum",
        },
      ],
      userIdsModal: false,
      userIdsData: [],
      userIdsColumns: [
        {
          title: "用户id",
          key: "user_id",
        },
      ],
      data9: [], // 用于存储查询结果
      columns10: [
        {
          title: "日期",
          key: "createtime",
        },
        {
          title: "发货用户数量",
          key: "userCount",
        },
        {
          title: "首次发货用户数",
          key: "firstUserCount",
          render: (h, params) => {
            const key = "firstUserCount";
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: params.row[key] == 0,
                  },
                  on: {
                    click: () => {
                      this.openUserIdsModal(params.row, "firstUserIds");
                    },
                  },
                },
                (params.row[key] || 0) + "人",
              ),
            ]);
          },
        },
        {
          title: "回归发货用户数",
          key: "returnUserCount",
          render: (h, params) => {
            const key = "returnUserCount";
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                    disabled: params.row[key] == 0,
                  },
                  on: {
                    click: () => {
                      this.openUserIdsModal(params.row, "returnUserIds");
                    },
                  },
                },
                (params.row[key] || 0) + "人",
              ),
            ]);
          },
        },
        {
          title: "当天发货成本",
          key: "costSum",
        },
        {
          title: "发货成本占比营业额",
          key: "totalRecharge",
          render: (h, params) => {
            const costSum = Number(params.row && params.row.costSum);
            const totalRecharge = Number(
              params.row && params.row.totalRecharge,
            );
            if (!totalRecharge || isNaN(costSum) || isNaN(totalRecharge)) {
              return h("span", "0.00%");
            }
            const percent = (costSum / totalRecharge) * 100;
            const text = (isNaN(percent) ? 0 : percent).toFixed(2) + "%";
            return h("span", text);
          },
        },
        {
          title: "发货最多的城市",
          key: "content",
        },
        {
          title: "发货成本排行",
          key: "totalExchangeIntegral",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  on: {
                    click: () => {
                      this.openRankModal(params.row);
                    },
                  },
                },
                "查看",
              ),
            ]);
          },
        },
      ],

      current: 1,
      total: 0,
      options3: {
        disabledDate(date) {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 将时间设置为当天的开始
          return date && date.getTime() > today.getTime() - 1;
        },
      },
    };
  },
  mounted() {
    this.queryGoods();
  },
  methods: {
    close() {
      this.visible = false;
    },
    openRankModal(row) {
      const createtime = row && row.createtime ? row.createtime : "";
      cmsShopStatisticsDetail({ rankdate: createtime })
        .then((res) => {
          const data = (res && res.data) || [];
          this.rankData = Array.isArray(data) ? data : [];
          this.rankModal = true;
        })
        .catch((err) => {
          console.error(err);
          this.rankData = [];
          this.rankModal = true;
        });
    },
    openUserIdsModal(row, key) {
      const ids = row && row[key] != null ? row[key] : [];
      let arr = [];
      if (Array.isArray(ids)) {
        arr = ids;
      } else if (typeof ids === "string") {
        arr = ids
          .split(/[,\n\r\t\s]+/)
          .map((v) => v.trim())
          .filter((v) => v);
      } else {
        arr = [];
      }
      this.userIdsData = arr.map((id) => ({ user_id: id }));
      this.userIdsModal = true;
    },
    // disabledDate(date) {
    //   // 禁止选择今天及以后的日期

    // },
    // 查询商品
    // 公共查询函数
    fetchGoodsData(params = {}) {
      cmsShopStatistics(params)
        .then((response) => {
          this.data9 = response.data.rows; // 获取查询结果
          this.current = response.data.pagination.page; // 获取当前页
          this.total = response.data.pagination.totalPages; // 获取总数
        })
        .catch((error) => {
          console.error(error);
        });
    },

    // 查询商品
    queryGoods() {
      var starttime = "";
      var endtime = "";
      if (this.searchDate.length > 0 && this.searchDate[0] != "") {
        starttime = this.formatDate(this.searchDate[0]);
        endtime = this.formatDate(this.searchDate[1]);
      }
      const params = {
        starttime,
        endtime,
        page: this.current,
      };
      this.fetchGoodsData(params);
    },
    // 格式化函数，将 Date 对象转换为 YYYY-MM-DD HH:mm:ss 格式
    formatDate(date) {
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const day = String(date.getDate()).padStart(2, "0");

      return `${year}-${month}-${day}`;
    },

    // 分页查询
    changePage(e) {
      this.current = e;
      this.queryGoods(); // 直接调用查询函数，不用重复逻辑
    },

    resetFormData() {
      // 重置表单数据
      this.searchId = "";
      this.searchName = "";
      this.searchPhone = "";
      this.searchDate = [];
      this.current = 1;
      this.queryGoods();
    },
  },
};
</script>
